<template>
    <div class="modal fade" :id="modalId" tabindex="-1" role="dialog" aria-labelledby="confirmModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content shadow-lg">
                <div class="modal-header">
                    <h5 class="modal-title">{{ title }}</h5>
                    <button
                        type="button"
                        class="close"
                        data-bs-dismiss="modal"
                        @click="handleCancel"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    {{ message }}
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-dark" data-bs-dismiss="modal" @click="handleCancel">Cancel</button>
                    <button type="button" class="btn btn-outline-success" @click="handleConfirm">Confirm</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ConfirmModal',
    props: {
        modalId: {
            type: String,
            required: true, // ID модального окна
        },
        title: {
            type: String,
            default: 'Are you sure?', // Заголовок окна
        },
        message: {
            type: String,
            default: 'Do you really want to perform this action?', // Сообщение
        },
    },
    methods: {
        handleConfirm() {
            console.log('Confirm:clicked');

            this.$emit('confirm'); // Генерация события "confirm"
            $(`#${this.modalId}`).modal('hide'); // Закрытие модального окна
        },

        handleCancel() {
            this.$emit('cancel');
        }
    },
};
</script>

<style scoped>
.modal-body {
    font-size: 16px;
}

.close {
    appearance: none; /* Убираем стандартные стили браузера */
    border: none; /* Убираем рамку */
    background: none; /* Убираем фон */
    color: #000; /* Цвет крестика (чёрный или другой) */
    font-size: 1.5rem; /* Размер крестика */
    font-weight: bold; /* Для более жирного шрифта крестика */
    line-height: 1; /* Уменьшаем высоту строки */
    opacity: 1; /* Убираем прозрачность */
    padding: 0; /* Убираем отступы */
    cursor: pointer; /* Указываем, что это кнопка (курсор меняется на указатель) */
    position: absolute; /* Позиционируем кнопку относительно окна */
    top: 10px; /* Отступ сверху */
    right: 15px; /* Отступ справа */
    transition: none; /* Убираем любые эффект при наведении */
}

/* Убираем эффекты при наведении */
.close:hover,
.close:focus {
    color: #000; /* Без изменений цвета */
    text-decoration: none; /* Убираем стандартное подчёркивание */
    background: none; /* Фон по умолчанию */
    outline: none; /* Убираем фокусное обведение */
}

.shadow-lg {
    box-shadow: 0 1rem 3rem black !important;
}
</style>
